import { tokens } from "../theme";
import { MenuItem, Select, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import ResponsivePagination from 'react-responsive-pagination';
// import 'react-responsive-pagination/themes/classic.css';
import './pagination.css';

export const PaginationFooter = ({ count = 1, pageSize, pageNumber, fetchMoreData }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const smScreen = useMediaQuery(theme.breakpoints.up("sm"));

    const isLocalPagination = pageSize === count && count > 100;
    const effectivePageSize = isLocalPagination ? 100 : pageSize;
    const totalPages = Math.ceil(count / effectivePageSize);

    const handlePageNumberChange = (num) => {
        fetchMoreData({ pageNumber: num });
    }
    const handlePageSizeChange = (e) => {
        fetchMoreData({ pageSize: e.target.value, pageNumber: 1 });
    }
    function getCurrentRows(rowsPerPage, currPage, rowCount) {
        var from = (rowsPerPage * currPage) - rowsPerPage + 1;
        var to = (rowsPerPage * currPage) > rowCount ? rowCount : rowsPerPage * currPage;
        if (rowCount === 0) return "0 of 0"
        else return from + "-" + to + " of " + rowCount;
    }

    const getPageSizeOptions = () => {
        let options = count > 0
            ? [5, 10, 50, 100].filter(opt => opt < count).concat([count])
            : [5, 10, 50, 100];
        return options;
    };

    const pageSizeOptions = getPageSizeOptions();

    return (
        <Stack
            p={1}
            bgcolor={colors.blueAccent[700]}
            overflow={"hidden"}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
        >
            <ResponsivePagination
                current={pageNumber ?? 1}
                total={totalPages || 1}
                onPageChange={handlePageNumberChange}
                maxWidth={smScreen ? 600 : 200}
            />
            <Stack direction="row" alignItems="center" spacing={2}>
                <Typography fontSize="small" noWrap>
                    {getCurrentRows(effectivePageSize, pageNumber, count)}
                </Typography>
                <Select
                    size="small"
                    // label="Rows per page"
                    value={pageSize ?? 10}
                    onChange={handlePageSizeChange}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left"
                        },
                        transformOrigin: {
                            vertical: "bottom",
                            horizontal: "left"
                        },
                    }}
                >
                    {pageSizeOptions.map((opt) => (
                        <MenuItem key={opt} value={opt}>
                            {opt}
                        </MenuItem>
                    ))}
                    {pageSize && !pageSizeOptions.includes(pageSize) && (
                        <MenuItem value={pageSize} style={{ display: 'none' }}>
                            {pageSize}
                        </MenuItem>
                    )}
                </Select>
            </Stack>
        </Stack>
    );
}